<template>
  <div class="form-field">
    <label>
      Locatie meetpunt
    </label>
    <input
        type="hidden"
        :value="JSON.stringify(currentValue)"
        :name="name"
    />

    <MapboxMap
        style="height: 380px; border-radius: 7px;
			border: solid 1px #dadde2; overflow: hidden;"
        :accessToken="accessToken"
        :mapStyle.sync="mapStyle"
        :center.sync="center"
        :zoom.sync="zoom"
        :scrollZoom="false"
        :dragRotate="false"
        @mb-created="mapLoad"
        ref="map"
    >
      <HydrographyLayer v-if="hydro"/>
      <MapboxMarker
          v-if="currentValue"
          :lng-lat="currentValue"
          :draggable="true"
          @mb-dragend="markerDragEnd"
		  ref="marker"
      >
		    <svg class="marker" width="24" height="30" viewBox="0 0 24 30" xmlns="http://www.w3.org/2000/svg"><path d="M12 0c6.627 0 12 5.373 12 12 0 11.427-12 18-12 18S0 23.427 0 12C0 5.373 5.373 0 12 0Zm0 7.2a4.8 4.8 0 1 0 0 9.6 4.8 4.8 0 0 0 0-9.6Z" fill="#DA503B" fill-rule="evenodd"/></svg>
	  </MapboxMarker>
	  <MapboxNavigationControl 
			position="top-right" 
			:showCompass="false"
	  />
	  <MapboxGeolocateControl 
	  	:trackUserLocation="true"
			:positionOptions="{enableHighAccuracy: true}"
			ref="tracker"
	  />
    </MapboxMap>
  </div>

</template>

<script>

import { MapboxMap, MapboxMarker, MapboxGeolocateControl, MapboxNavigationControl } from '@studiometa/vue-mapbox-gl';

import 'mapbox-gl/dist/mapbox-gl.css';
import HydrographyLayer from "../../HydrographyLayer";
// import BoxMarkers from "../../BoxMarkers";
// import Clusterer from "../../Clusterer";

export default {
  name: "MapInput",
	components: {
    MapboxMap,
		MapboxGeolocateControl,
		MapboxMarker,
		HydrographyLayer,
		MapboxNavigationControl
	},

	props: {
		name: {
			type: String,
			default: '',
		},
		modelValue: {
			type: Array,
			default() {
				return null;
			},
		},
		defaultCenter: {
			type: Object,
			default() {
				return [5.12, 52.09];
			}
		},
		hydro: {
			type: Boolean,
			default: true,
		},
	},

	data() {
		return {
			accessToken:
					'pk.eyJ1Ijoic2VwdGVtYmVyZGlnaXRhbCIsImEiOiJjbDM5NTMxaWcwNmVqM2RxbTgwYTZwc2R6In0.muheCHZVNeU2x8FHymhtuQ', // your access token. Needed if you using Mapbox maps
			mapStyle: 'mapbox://styles/mapbox/streets-v11?optimize=true', // your map style
			zoom: 7,
			currentValue: this.modelValue,
			center: {},
			map: null,
		};
	},

	created() {

		this.center = this.defaultCenter;

		if (this.currentValue) {
			this.center = this.currentValue;
		}
	},
  watch: {
		currentValue(){
			this.$emit('update:modelValue', this.currentValue);
		}
	},
	methods: {
		markerDragEnd(evt){
			this.currentValue = [evt.target._lngLat.lng, evt.target._lngLat.lat];
		},

		mapLoad(map){
			map.on('click', (e) => {
				this.currentValue = [e.lngLat.lng, e.lngLat.lat];
			});

			map.loadImage('/app/themes/natuur-en-milieu/campagnes/watermonsters/dist/images/marker-default.png', (error, image) => {
				if(error){
					throw error;
				}

				map.addImage('watermonsters-marker', image);
			});

			const interval = setInterval(() => {
				const controls = map._controls;

				controls.forEach(control => {
					if(control.options?.showUserLocation){
						control.trigger();
						clearInterval(interval);
					}
				});
			}, 1000);


			// if (navigator.geolocation) {
			// 	navigator.geolocation.getCurrentPosition(position => {
			// 		console.log(position);
			// 	})
			// }

		},
	}
};
</script>

<style scoped>
	input[type="text"] {
		display: none;
	}
  .mapboxgl-map {
    position: relative;
	overflow: hidden;
    height: 380px;
  }

	.map-legend h4 {
		font-weight: bold;
		margin: 0 0 20px;
	}
	.marker {
		transform: translate(-2px, -12px);
	}
</style>
